import React, { useState } from "react"

// import { getPermissionConfigs } from "../configs/permissionConfigs"

// import { useAuthAccess, authTargetSystemRouteTypes } from "./useAuthAccess"

export const scopes = {
    display: "display"
}

const defaultConfigs = {
    display: {
        sidebarAlwaysHide: false
    }
}

const getStorageValue = (key) => (
    JSON.parse(localStorage.getItem(key))
)

const setStorageValue = (key, value) => (
    localStorage.setItem(key, JSON.stringify(value))
)

const STOREKEY = `browserConfigs`

export function useBrowserConfigs(_routeType = '') {

    const [routeType, setRouteType] = useState(_routeType)

    const updateConfigs = (_scope, _config) => {

        let invalidScope = false
        let invalidKey = false

        // check the scope key
        let _checkScope = Object.keys(scopes).filter(i => i === _scope)

        if (_checkScope.length <= 0) {
            invalidScope = true
        }

        // check the config key
        Object.keys(_config).forEach(i => {
            let _checkKey = Object.keys(defaultConfigs[_scope]).filter(i2 => i2 === i)
            if (_checkKey.length <= 0) {
                invalidKey = true
            }
        })

        console.log('invalid Scope', invalidScope, _config, _scope)
        console.log('invalid Key', invalidKey, _config, _scope)

        if (invalidScope === true) {
            console.error(`BrowserConfigsError: Invalid Scope (${_scope})`)
            return false;
        }

        if (invalidKey === true) {
            console.error(`BrowserConfigsError: Invalid Key (${JSON.stringify(_config)})`)
            return false;
        }

        let savedConfigs = {
            ...defaultConfigs,
            [_scope]: {
                ...defaultConfigs[_scope],
                ..._config
            }
        }

        console.log('savedConfigs', savedConfigs)

        setStorageValue(STOREKEY, savedConfigs)

        return true
    }

    const getConfigs = (_scope, keyArray = []) => {

        let _a = getStorageValue(STOREKEY)

        if (_a === null) _a = {}

        let hasScope = _scope in _a;

        if (hasScope === false) {

            let returnValues = {}

            if (keyArray.length > 0) {
                keyArray.forEach(i => {
                    returnValues = {
                        ...returnValues,
                        [i]: null
                    }
                })
            }

            return returnValues
        }

        // has scope found
        let c = _a[_scope]

        // console.log('_a', _a, hasScope)

        return c

    }

    return {
        updateConfigs,
        getConfigs
    }
}